import { FC } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';

import InventoryExportDetail from './InventoryExportDetail';

const InventoryExportDetailClassWrapper: FC = () => {
  const [, { navigate, params }] = useNavigation();
  const { id } = params;
  return <InventoryExportDetail id={id} navigate={navigate} />;
};
export default InventoryExportDetailClassWrapper;
